/** MetricValue.source for HealthKit sync rows. */
export const METRIC_VALUE_SOURCE_HEALTHKIT = 'healthkit';

/** MetricValue.source for Android Health Connect sync rows. */
export const METRIC_VALUE_SOURCE_HEALTH_CONNECT = 'health-connect';

/** OsConnection.provider for HealthKit (same slug as MetricValue.source). */
export const OS_CONNECTION_PROVIDER_HEALTHKIT = 'healthkit';

/** OsConnection.provider for Android Health Connect. */
export const OS_CONNECTION_PROVIDER_HEALTH_CONNECT = 'health-connect';

/** Registered OS connection providers (screen time excluded). */
export const OS_CONNECTION_PROVIDERS = [
  OS_CONNECTION_PROVIDER_HEALTHKIT,
  OS_CONNECTION_PROVIDER_HEALTH_CONNECT,
] as const;

export type OsConnectionProvider = (typeof OS_CONNECTION_PROVIDERS)[number];

/**
 * Returns whether a string is a registered OS connection provider.
 * @param value Candidate provider slug.
 */
export function isOsConnectionProvider(value: string): value is OsConnectionProvider {
  return (OS_CONNECTION_PROVIDERS as readonly string[]).includes(value);
}
